<template>
  <div class="cs-qr">
    <h4 class="scan-qr">{{ $t("qr-code.scan-code") }}</h4>
    <!-- {{ anyWalletCoin }} -->
    <b-link href="#" class="w-100 instructions-list" :class="showInstructionsDropdown ? null : 'collapsed'"
      aria-controls="collapse-4" @click="toggleDetailedInstructions">Detailed Instructions
      <img :src="!showInstructionsDropdown
        ? require('@/assets/img/down-arrow1.svg')
        : require('@/assets/img/down-arrow2.svg')
        " alt="toggle instructions" />
    </b-link>
    <b-collapse id="collapse-4" v-model:open="showInstructionsDropdown" class="mt-2">
      <div class="instructions details ml-n3">
        <InstructionsList :anyWalletCoin="anyWalletCoin" :store="store" />
      </div>
    </b-collapse>
    <template v-if="showInstructionsDropdown == false">
      <div v-if="qrData && qrData.meta && getTag(qrData.meta.receiverAddress)"
          class="d-flex align-items-center justify-content-center flex-column">
          <div class="combined-warning-box">
            <div class="warning-section">
              <span class="warning-icon-small">
                <img src="@/assets/img/warning.svg" alt="warning" />
              </span>
              <span class="warning-text">
                <strong>{{ $t('tag.important') }}</strong> {{ $t('tag.importantText') }}
              </span>
            </div>
            <div class="tag-section">
              <div class="tag-header">
                <span class="label">{{ $t('tag.destinationTag') }}</span>
              </div>
              <div class="tag-main">
                <span class="tag-value">{{ getTag(qrData.meta.receiverAddress) || '' }}</span>
                <button class="copy-btn2" v-clipboard="getTag(qrData.meta.receiverAddress)"
                  v-clipboard:success="ClipboardSuccessHandler" @click.prevent="handleCopyClick2">
                  <img v-if="!isCopied2" src="@/assets/img/Copy_alt.svg" alt="copy" class="copy-icon" />
                  <span v-if="!isCopied2">{{ $t('tag.copyTag') }}</span>
                  <span v-if="isCopied2">{{ $t('tag.copied') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      <div class="cs-qramoountbox text-center">
        <div class="cs-qr__amount" v-if="payableData.payable_amount">
          <!-- <div class="cs-qr__amount" v-if="payableAmount || (qrData && qrData.nativeAmount)"> -->
          <!-- Already using USD -->
          <!-- {{NumberFormat(DecimalNumber
          (qrData.nativeAmount).div(
            conversionRate2.currentRate))}} -->
          <span>
            {{ NumberFormat(payableData.payable_amount) }}
          </span>
          <span class="d-inline ml-2  ">
            {{
              payableData.payable_currency && !anyWalletError
                ? payableData.payable_currency == "USDT"
                  ? "USDT(ERC20)"
                  : payableData.payable_currency
                : ""
            }}
            <!-- <img :src="anyWalletCoin.chainsNetworkLogo" id="chainsNetworkLogo"
           class="d-inline chainsNetworkLogo"/>
          <b-tooltip
          target="chainsNetworkLogo"
           placement="top"
          class="text-capitalize "
        >
        <span class="text-capitalize d-block">Currency: {{anyWalletCoin.currency}}</span>
         <span class="text-capitalize">Network: {{anyWalletCoin.chainNetwork}}</span>
        </b-tooltip> -->
          </span>
          <h4 class="px-3 lh-5" v-if="Number(payableData.stableCoinProcessingFee) > 0">
            <span class="text-dark p-1 text-center">
              {{
                "(includes " +
                payableData.stableCoinProcessingFee +
                " " +
                payableData.payable_currency +
                " processing fee)"
              }}
            </span>
          </h4>
           <h4 class="d-flex px-2 py-0" v-if="anyWalletCoin.networkMsg != ''">
             <span class="warning-icon-small">
               <img src="@/assets/img/warning.svg" alt="warning" />
             </span>
             <span class="scan-qr p-1 text-left network-msg" v-html="anyWalletCoin.networkMsg" />
           </h4>
        </div>
        <div class="cs-qr__amount" v-else>- - -</div>
        <div class="text-center m-auto">
          <div v-if="qrData && qrData.meta" class="text-center m-auto">
            <vue-qr :style="isCodeExpired ? { opacity: 0.1 } : {}" v-if="qrData && qrData.meta"
              :text="qrData.meta ? qrData.meta.qrString : ''" class="cs-qr__code" />
            <div class="cs-qr__code border" v-else>
              <Loading />
            </div>
          </div>
          <div class="cs-qr__code mx-auto d-flex justify-content-center align-items-center" v-else>
            <Loading />
          </div>
        </div>
        <div class="cs-qr__rate" v-if="exchangeRateLabel">
          <span class="cs-qr__rate-label">{{ $t("qr-code.exchange-rate") }}:</span>
          <span class="cs-qr__rate-value">{{ exchangeRateLabel }}</span>
        </div>
      </div>
      <div :class="!qrData || !qrData.meta ? 'disable-events' : ''">
        <div class="" v-if="qrData && qrData.meta">
          <div class="cs-qrcopybox mx-auto d-flex justify-content-between align-items-center">
            <span class="ml-2">
              {{
                qrData.meta && qrData.meta.receiverAddress
                  ? ShortText(qrData.meta.receiverAddress, 10)
                  : ""
              }}</span>
            <div v-if="!isCodeExpired" v-clipboard="getReceiverAddress(qrData.meta.receiverAddress)"
              v-clipboard:success="ClipboardSuccessHandler" @click.prevent="handleCopyClick" class="btn copy-btn">
              <img v-if="!isCopied" src="@/assets/img/Copy_alt.svg" alt="copy" />
              <span v-if="isCopied" class="copied-message">{{ $t('tag.copied') }}</span>
            </div>
          </div>
        </div>

      </div>

      <b-modal v-model="isCodeExpiredVar" centered hide-header hide-footer no-close-on-backdrop>
        <div class="qr-expired-modal">
          <h5>{{ $t("qr-expired.title") }}</h5>
          <p class="text-left mb-1">{{ $t("qr-expired.desc1") }}</p>
          <p class="text-left">
            {{ $t("qr-expired.description") }}
            <a :href="shopperUrl" target="_blank">Portal here</a>.
          </p>
          <div v-if="isInIframe" class="text-center mt-3">
            <button class="btn btn-primary close-widget-btn" @click="closeWidget">
              {{ $t("popup-modal.ok") }}
            </button>
          </div>
        </div>
      </b-modal>
    </template>

    <b-modal v-model="isInstructions" centered hide-header hide-footer>
      <div class="instructions first-instructions ml-n3">
        <InstructionsList :anyWalletCoin="anyWalletCoin" :store="store" />
        <div class="d-flex flex-row align-items-center">
          <input :checked="isInstructionsRepeated ? true : false" type="checkbox" class="checkbox"
            @click="doNotRepeatInstructions($event)" />
          <div class="mt-1">Do not show this again?</div>
        </div>
      </div>
      <div class="text-center mt-1">
        <b-button size="sm" class="footer-btn cursor-pointer w-25 ok-btn" @click="closeInstructions">
          <b>{{ $t("popup-modal.ok") }}</b>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
/* eslint-disable global-require */

import Loading from "@/components/Loading.vue";
import InstructionsList from "@/components/CryptoWallet/InstructionsList.vue";
import { USER_TRACK_EVENTS } from "@/store/modules/user/consts";

export default {
  components: {
    Loading,
    InstructionsList,
  },
  props: {
    qrData: Object || {},
    anyWalletCoin: Object || {},
    anyWalletError: String || "",
    convertedCart: Object || {},
    displayCurrency: Object || {},
    currencies: Array || [],
    isPreview: Boolean,
    payableData: Object || {},
    isCodeExpired: Boolean,
    isContinuedTransaction: Boolean,
  },
  computed: {
    ...mapGetters({
      paymentOptions: "user/paymentOptions",
      store: "user/marketInfo",
    }),
    isInIframe() {
      return window.top !== window.self;
    },
    conversionRate2() {
      let rate = {};
      this.currencies.forEach((item) => {
        if (this.anyWalletCoin?.currency) {
          if (
            item.id.toLowerCase() === this.anyWalletCoin.currency.toLowerCase()
          ) {
            rate = item;
          }
        }
      });
      return rate;
    },
    assetSymbol() {
      const symbol =
        this.anyWalletCoin?.currency || this.payableData?.payable_currency;
      return symbol ? String(symbol).toUpperCase() : "";
    },
    displayCurrencyCode() {
      const code =
        this.displayCurrency?.code ||
        this.displayCurrency?.currency ||
        this.displayCurrency?.id ||
        this.payableData?.payable_currency ||
        "";
      return code ? String(code).toUpperCase() : "";
    },
    exchangeRateLabel() {
      let rate = Number(this.payableData?.conversion_rate_per_unit);
      
      const base = this.assetSymbol;
      const target = this.displayCurrencyCode;
      if(target.toLowerCase() !== "usd") {
        rate = Number(this.payableData?.conversion_rate_per_unit) / Number(this.displayCurrency?.currentRate);
      }
      if (!base || !target || !Number.isFinite(rate) || rate <= 0) {
        return "";
      }
      const formattedRate = this.formatExchangeRate(rate);
      return formattedRate ? `1 ${base} ≈ ${formattedRate} ${target}` : "";
    },
  },
  data() {
    return {
      shopperUrl: process.env.VUE_APP_SHOPPER_URL,
      saved: false,
      isInstructions: false,
      showInstructionsDropdown: false,
      isInstructionsRepeated: false,
      isCodeExpiredVar: false,
      isCopied: false,
      currentSession: false,
      isCopied2: false,

    };
  },
  watch: {
    allPaymentTabs() {
      this.init();
    },
    isCodeExpired(val) {
      this.isCodeExpiredVar = val;
    },
  },
  mounted() {
    this.init();
    this.isInstructionsRepeated =
      this.$DbStorage.getItem("doNotRepeatInstructions") === "true";
    this.currentSession = (this.$DbStorage.getItem('currentSessionInstructions') === 'true');
    if (
      !this.isInstructionsRepeated &&
      !this.isContinuedTransaction &&
      !this.isCodeExpired && !this.currentSession
    ) {
      this.isInstructions = true;
      this.$DbStorage.setItem('currentSessionInstructions', 'true');
    }
  },
  methods: {
    toggleDetailedInstructions() {
      this.showInstructionsDropdown = !this.showInstructionsDropdown;

      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Crypto Wallet tab",
          activity: `detailed instructions ${this.showInstructionsDropdown ? "opened" : "closed"
            }`,
        },
      });
    },
    handleCopyClick(event) {
      // Prevent the default click behavior
      event.preventDefault();

      const isSuccess = true;

      if (isSuccess) {
        // Set isCopied to true to show the "Copied" message
        this.isCopied = true;

        // Reset isCopied after a delay (e.g., 2 seconds)
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
      }
    },
    handleCopyClick2(event) {
      // Prevent the default click behavior
      event.preventDefault();

      const isSuccess = true;

      if (isSuccess) {
        // Set isCopied to true to show the "Copied" message
        this.isCopied2 = true;

        // Reset isCopied after a delay (e.g., 2 seconds)
        setTimeout(() => {
          this.isCopied2 = false;
        }, 2000);
      }
    },
    ClipboardSuccessHandler(value) {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: "Crypto Wallet tab",
          activity: `clicked on copy button, Wallet Address/Tag copied.`,
        },
      });
    },
    closeIframe() {
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: false,
      });
    },
    doNotRepeatInstructions(val) {
      this.$DbStorage.setItem("doNotRepeatInstructions", val.target.checked);
    },
    copySuccess() {
      this.saved = true;
      setTimeout(() => {
        this.saved = false;
      }, 500);
    },
    init() { },
    getReceiverAddress(address) {
      if (address.split(":::ucl:::").length > 1) {
        return address.split(":::ucl:::")[0];
      }
      return address;
    },
    formatExchangeRate(value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }

      try {
        const decimalValue = this.DecimalNumber(value);
        return decimalValue.toFixed(2);
      } catch (error) {
        console.error("Failed to format exchange rate:", error);
        return String(value);
      }
    },
    closeInstructions() {
      this.isInstructions = false;
      window.EventBus.emit(`startCountdown`);
    },
    showInstructions() {
      this.isInstructions = true;
    },
    getTag(address) {
      if (address.split(":::ucl:::").length > 1) {
        return address.split(":::ucl:::")[1];
      }
      return null;
    },
    ShortText(text, size) {
      text = text.split(':::ucl:::')[0];
      if (!text) {
        return `-`;
      }
      if (size) {
        return `${text.slice(0, size)}...${text.slice(-size)}`;
      }
      if (text.length > 25 && !size) {
        return `${text.slice(0, 25)}...`;
      }
      return text;
    },
    closeWidget() {
      this.isCodeExpiredVar = false;
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: false,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#tip {
  float: right;
  margin-top: 8px;
  cursor: pointer;
}

.footer-btn {
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px 10px;
  color: #303030 !important;
}

.footer-btn-2 {
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px 10px;
  color: white !important;
}

.cs-qr {
  // border: 1px solid $border;
  // border-radius: 1px;
  // display: flex;
  // padding: 5px;
  justify-content: center;
  align-items: center;

  &__code {
    width: 150px;
    min-width: 120px;
    height: 150px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 10px;
  }

  &__coin-box {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  &__icon {
    width: 21px;
    min-width: 21px;
    height: 21px;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 10px;
  }

  &__name {
    font-size: 14px;
    line-height: 17px;
  }

  &__amount {
    font-weight: 900;
    font-size: 24px;
    line-height: 21px;
    margin-top: 10px;
  }

  &__convert {
    font-weight: 300;
    font-size: 14px;
    line-height: 23px;
    color: $black400;
    margin-bottom: 8px;
  }

  &__hr {
    width: 10%;
    height: 1px;
    background-color: #888786;
  }

  &__or {
    font-size: 12px;
    color: #888786;
  }

  &__copy {
    width: 120px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5559fe;
    border: 1px solid #5559fe;
    border-radius: 1px;
    font-size: 12px;
    line-height: 23px;
    color: $white;
    transition: 0.3s;
    //transform: translateX(96px);
    margin-bottom: 10px;
    margin-top: 6px;
    text-transform: uppercase;

    &:hover {
      border-color: #5559fe;
      color: #5559fe;
      background-color: $white;
    }

    &_success {
      border-color: $green500 !important;
      color: $green500 !important;
    }
  }

  &__infoText {
    display: flex;
    padding: 7px 8px;
    border-radius: 4px;
    color: #7e7e7e;
    background-color: #f2f2f2;
    line-height: 15px;
    font-size: 13px;

    div {
      margin-right: 4px;

      img {
        width: 20px;
        margin-top: 1px;
        margin-right: 5px;
      }

      ol {
        padding: 0px 0px 0px 15px;
        margin-bottom: 0px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }

  &__rate {
    font-size: 14px;
    color: #000000;
    margin: 12px auto 0;
    max-width: 280px;
  }

  &__rate-label {
    font-weight: 600;
    margin-right: 4px;
  }
}

// .cs-qr {
//   h4 {
//     font-weight: 500;
//     font-size: 12px;
//     line-height: 19px;
//     color: #5559fe;
//     margin: 10px -15px;
//     text-align: center;
//   }
// }

.expired-overlay {
  background: #ffffff;
  box-shadow: 0px 5px 5px #ddd;
  padding: 10px;
  margin: 0px 20px 0px 10px;
  border-radius: 10px;
  text-align: center;
  color: black;
  position: absolute;

  h5 {
    font-size: 15px;
    text-decoration: underline;
  }

  p {
    font-size: 14px;
  }
}

.instruction-note {
  line-height: 1.7;
  font-size: 12px;
  margin-left: 25px !important;
  font-weight: 500;
}

.checkbox {
  margin: 0px 10px -2px 25px !important;
  font-size: 14px;
  cursor: pointer !important;
}

.disable-events {
  pointer-events: none !important;
}

.cs-qramoountbox {
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 280px;
  margin: 10px auto;
}

.cs-qrcopybox {
  border: 1px solid rgba(0, 0, 0, 0.4);
  width: 280px;
  margin: -10px auto auto 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.instructions-list {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  text-decoration-line: underline;
  color: #000000;
  text-align: center;

  img {
    display: inline-block;
  }
}

.first-instructions.instructions {
  color: #000000;
  letter-spacing: 0em;
  text-align: left;
  font-size: 13px;
  background: #ffffff;
}

.details.instructions {
  color: #000000;
  letter-spacing: 0em;
  text-align: left;
  font-size: 13px;
  z-index: 1;
  padding: 5px;
  width: 95%;
  background: #ffffff;
}

::v-deep(.collapse) {
  max-height: none !important;
}

.ok-btn {
  color: white !important;
}

.chainsNetworkLogo {
  width: 20px;
}

.copy-btn {
  margin-left: 4px;
  cursor: pointer;
}

.scan-qr {
  width: 100%;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  color: #5559fe;
  text-align: center;
}

.lh-5 {
  font-size: 14px;
}

.copied-message {
  font-size: 14px;
  max-width: 100%;
  display: block;
}

.destination-tag-box {
  border: 2px dashed #90cdf4;
  border-radius: 12px;
  padding: 5px 15px;
  background: #fff;
  margin-top: 14px;
  max-width: 100%;
  box-sizing: border-box;
  width: 100%;
}

.tag-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  color: #2563eb;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.tag-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tag-value {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  flex: 1;
  word-break: break-all;
  margin-right: 8px;
}

.warning-box {
  background: #fef2f2;
  border: 2px solid #fca5a5;
  border-radius: 8px;
  padding: 6px 10px;
  display: flex;
  align-items: flex-start;
  gap: 5px;
  color: #dc2626;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1);

  strong {
    color: #dc2626;
    font-weight: 700;
    font-size: 15px;
  }
}

.combined-warning-box {
  background: #fef2f2;
  border: 2px dashed #fca5a5;
  border-radius: 12px;
  padding: 12px 16px;
  margin: 8px 0;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);
  width: 100%;
}

.warning-section {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 0;
}

.warning-text {
  color: #dc2626;
  font-size: 13px;
  line-height: 1.4;
  
  strong {
    color: #dc2626;
    font-weight: 700;
    font-size: 14px;
  }
}

.tag-section {
  padding: 0 18px;
  .tag-header {
    margin-bottom: 8px;
  }
  
  .tag-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
}

.warning-icon {
  font-size: 16px;
  color: #dc2626;
  font-weight: bold;

  img {
    width: 25px;
    height: 25px;
    filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);
  }
}

/* SVG color inheritance classes */
.warning-icon-red img {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);
}

.warning-icon-default img {
  filter: none;
  /* Keep original color */
}

.copy-btn2 {
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  margin-top: -10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.copy-btn2:hover {
  background: #1e40af;
}

.copy-icon {
  width: 20px;
  height: 20px;
  filter: brightness(0) saturate(100%) invert(100%);
}

.network-msg {
  color: #dc2626;
}

.warning-icon-small {
  font-size: 16px;
  margin-top: 5px;
  color: #dc2626;
  font-weight: bold;
  
  img {
    width: 16px;
    height: 16px;
    filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);
  }
}

.qr-expired-modal {
  position: relative;
  padding: 20px;
}


.close-widget-btn {
  background-color: #5559fe;
  border: 1px solid #5559fe;
  color: white;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #4444e6;
    border-color: #4444e6;
  }
}

</style>
